import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { ConfirmationActionSheetController } from './confirmation-action-sheet.controller';
import { ConfirmationActionSheetProps } from './confirmation-action-sheet.types';

export type { ConfirmationActionSheetProps } from './confirmation-action-sheet.types';
export { ConfirmationActionSheetController } from './confirmation-action-sheet.controller';

// TODO remove direct usage and replace with hook
export const confirmationActionSheetModalId = 'confirmation-action-sheet';
const ConfirmationActionSheetModal = NiceModal.create(ConfirmationActionSheetController);
NiceModal.register(confirmationActionSheetModalId, ConfirmationActionSheetModal);

// TODO remove direct usage and replace with hook
export const openConfirmationActionSheet = (props: ConfirmationActionSheetProps) =>
  NiceModal.show(confirmationActionSheetModalId, props);

export const useConfirmationActionSheet = () => {
  const { show } = useModal(ConfirmationActionSheetModal);
  return useMemo(() => ({ open: show }), [show]);
};
